module.exports = __webpack_public_path__ + "static/media/hellMusic.ba51b78c.mp3";